// extracted by mini-css-extract-plugin
export default {"switch":"ToggleButton_switch__UW+L1","checked":"ToggleButton_checked__T-TYE"};